import type { ButtonProps } from '@sravni/react-design-system/lib/Button';

import { OFFER_STATUS } from 'constants/offer';

import { isPreApprovalOffer } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';

import { GoToRefOffer, MfoFinalButton, MfoFullDealButton, PledgeAuto, SendOffer } from 'features/OfferControls/ui';
import { PledgeEstate } from 'features/OfferControls/ui/PledgeEstate';

import { Locked } from '../ui/Locked/Locked';
import { MoreInfo } from '../ui/MoreInfo/MoreInfo';
import { PreApprovalOfferControls } from '../ui/PreApprovalOfferControls';

// Поправить архитектуру файлов в рамках задачи CF-4101
// eslint-disable-next-line max-statements
export const getControlsByOffer = (
  offer: TOffer,
  controlButtonProps?: Pick<ButtonProps, 'size' | 'color' | 'type' | 'className' | 'onClick'>,
) => {
  const { status, additionalInfo, group, category, type } = offer;

  if (isPreApprovalOffer(offer)) {
    return [
      <PreApprovalOfferControls
        key={0}
        offer={offer}
        buttonProps={controlButtonProps}
      />,
    ];
  }

  if (group === 'MfoFullDeal') {
    return [
      <MfoFullDealButton
        key={0}
        offer={offer}
        buttonProps={controlButtonProps}
      />,
    ];
  }

  if (category === 'MicroCredit' && type === 'mfoStatus') {
    if (additionalInfo?.dealStatus === 'rejected') {
      return [
        <MfoFullDealButton
          key={0}
          offer={offer}
          buttonProps={controlButtonProps}
        />,
      ];
    }

    return [
      <MfoFinalButton
        key={0}
        offer={offer}
        buttonProps={controlButtonProps}
      />,
    ];
  }

  if (status === OFFER_STATUS.ALREADY_SENT_FROM_SAME_BANK) {
    return [
      <MoreInfo
        offer={offer}
        key={0}
        buttonProps={controlButtonProps}
      />,
    ];
  }

  if (additionalInfo?.isFake) {
    return [
      <Locked
        key={0}
        buttonProps={controlButtonProps}
      />,
    ];
  }

  if (status === OFFER_STATUS.NEW) {
    // реферальный оффер мфо
    if (additionalInfo?.isReferral) {
      return [
        <GoToRefOffer
          key={0}
          offer={offer}
          buttonProps={controlButtonProps}
        />,
      ];
    }

    // для попапа с данными залогового авто
    if (additionalInfo?.isAutoPledge) {
      return [
        <PledgeAuto
          key={0}
          offer={offer}
          buttonProps={controlButtonProps}
        />,
      ];
    }

    // для попапа с данными залоговой недвижимости
    if (additionalInfo?.isPropertyPledge) {
      return [
        <PledgeEstate
          key={0}
          offer={offer}
          buttonProps={controlButtonProps}
        />,
      ];
    }

    return [
      <SendOffer
        key={0}
        offer={offer}
        buttonProps={controlButtonProps}
      />,
    ];
  }

  return [
    <MoreInfo
      offer={offer}
      key={0}
      buttonProps={controlButtonProps}
    />,
  ];
};
